import { normalizeCalendarFormIdentity } from "./calendarFormIdentity";

const hasValue = (value) => value !== undefined && value !== null && value !== "";

const completeDuration = (value) => {
  const match = /^(\d{1,2}):(\d{2})$/.exec(String(value || ""));
  if (!match) return false;
  const hours = Number(match[1]);
  const minutes = Number(match[2]);
  return minutes < 60 && hours * 60 + minutes > 0 && hours * 60 + minutes <= 24 * 60;
};

const slotDuration = (minutes) => {
  const safeMinutes = Number.isFinite(Number(minutes)) && Number(minutes) > 0
    ? Number(minutes)
    : 15;
  return `${String(Math.floor(safeMinutes / 60)).padStart(2, "0")}:${String(safeMinutes % 60).padStart(2, "0")}`;
};

export const buildAppointmentAvailabilityRequest = (values = {}, overrides = {}) => {
  const request = { ...values, ...overrides };
  if (!hasValue(request.service_id) || !hasValue(request.staff_id) ||
      !hasValue(request.dateof) || !completeDuration(request.duration)) {
    return null;
  }
  return {
    ...request,
    listview: "Appointment",
    formtype: "appointmentform",
    isDurationCheck: true,
    list_all_slots: request.list_all_slots === true || request.form_types === "edit_appointment" || request.pagetype === "edit_appointment",
    selectedOptionType: "",
  };
};

export const buildBusyTimeAvailabilityRequest = (values = {}, {
  formtype,
  availableBusyTime,
  slotMinutes = 15,
  ...overrides
} = {}) => {
  const request = { ...values, ...overrides };
  const identity = normalizeCalendarFormIdentity({ ...request, formtype });
  const resolvedFormType = identity.kind === "busy-time"
    ? `${identity.mode}_busytime`
    : (formtype || request.formtype || request.form_types);
  if (!hasValue(request.staff_id) || !hasValue(request.dateof) ||
      !["add_busytime", "edit_busytime"].includes(resolvedFormType) ||
      !["start", "end"].includes(availableBusyTime)) {
    return null;
  }
  const duration = availableBusyTime === "start"
    ? (request.duration || slotDuration(slotMinutes))
    : "";
  const serviceFreeRequest = { ...request };
  delete serviceFreeRequest.service_id;
  return {
    ...serviceFreeRequest,
    listview: "BusyTime",
    formtype: resolvedFormType,
    availableBusyTime,
    duration,
    durationWithPadding: availableBusyTime === "start"
      ? (request.durationWithPadding || duration)
      : "",
    isDurationCheck: true,
  };
};
